var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edex-header',{attrs:{"selfIsLoading":_vm.selfIsLoading,"locationPathname":_vm.locationPathname},on:{"requestMetadata":_vm.onRequestMetadata,"searchChanged":_vm.onSearch}})}
var staticRenderFns = []

export { render, staticRenderFns }